import React, { useState, useEffect, useCallback } from "react";
// router
import { useParams } from "react-router";
// redux
import { useSelector } from "react-redux";
// formik
import { useFormik } from "formik";
// axios
import EnhancedAxios from "../../../api/EnhancedAxios";
// mui
import { Stack, TextField, FormControlLabel, Switch } from "@mui/material";
// components
import { PageTitle, SubmitButton, RingsLoader } from "../../../components";
import { ErrorsStack } from "../../../sections";
// form validation schema
import { addCitySchema } from "../../../schemes/cities/addCitySchema";
// alerts
import { errorAlert, successAlert } from "../../../utils/alerts";

const EditCity = () => {
    const { cityId } = useParams(); // get id of the city from the url
    const userToken = useSelector((state) => state.userToken);
    const [loading, setLoading] = useState(true);
    // ---------- submit_form_function ----------
    const onSubmit = (values) => {
        const formData = new FormData();
        for (let i in values) {
            formData.append(i, values[i]);
        }
        EnhancedAxios("multipart/form-data", userToken)
            .put(`/admin/cities/${cityId}`, formData)
            .then((res) => successAlert("تم تعديل المدينة بنجاح"))
            .catch((error) => errorAlert(error))
            .finally(() => setSubmitting(false));
    };
    // ---------- form_configration ----------
    const {
        values,
        setValues,
        handleChange,
        handleSubmit,
        handleBlur,
        errors,
        touched,
        isSubmitting,
        setSubmitting,
        resetForm,
    } = useFormik({
        initialValues: {
            name: "",
            is_disabled: false,
        },
        validationSchema: addCitySchema,
        onSubmit,
    });
    // ---------- get_current_city_data ----------
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/admin/cities/${cityId}`)
            .then((res) => {
                setValues((prev) => ({
                    ...prev,
                    name: res.data.name,
                    is_disabled: res.data.is_disabled,
                }));
                setLoading(false);
            });
    }, []);
    // ---------- page_ui ----------
    if (loading) <RingsLoader />;
    return (
        <Stack gap="20px" alignItems="center">
            <PageTitle title="تعديل مدينة" />
            <Stack
                spacing={1}
                component="form"
                width="100%"
                maxWidth="700px"
                onSubmit={handleSubmit}
            >
                <TextField
                    name="name"
                    label="اسم المدينة"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={!values.is_disabled}
                            onChange={(e) =>
                                setValues((prev) => ({
                                    ...prev,
                                    is_disabled: !e.target.checked,
                                }))
                            }
                            name="is_disabled"
                        />
                    }
                    label="تفعيل"
                />
                <SubmitButton text="تعديل" disabled={isSubmitting} />
                <ErrorsStack errors={errors} touched={touched} />
            </Stack>
        </Stack>
    );
};

export default EditCity;
